








import { Component, Vue, Prop } from "vue-property-decorator";
import { AppConstants, apiService } from "@/core/Export";

import store from "@/store";

@Component({ components: {} })
export default class NotActivePage extends Vue {
  get logoImg() {
    if (this.systemData && this.systemData["systemSettings"]) {
      var url: string = AppConstants.Http.BaseUrl;
      url = url.replace("/api", "");
      return `${url}/logos/${this.systemData["systemSettings"].authorityCode}.png`;
    } else {
      return;
    }
  }

  get systemData() {
    return store.getters.systemData;
  }
}
